<template>
    <b-overlay :show="busy" rounded="sm">
        <b-card class="standardpage">

            <b-card-body class="mb-3 py-0 px-0">
                <b-tabs class="gridtabs" v-model="tabindex">
                    <b-tab>
                        <template #title>
                            <div class="badgecontainer pr-2 mr-1">
                                <i :class="options.icon" class="mr-1"></i>
                                <span>{{ options.title }}</span>
                            </div>
                        </template>

                        <p class="mt-0">
                            <b-row>
                                <b-col>
                                    <b-alert :show="true" variant="secondary">
                                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                            <b-col>
                                                <span class="h6"> You may turn the invoicing system on or off from here.
                                                    When the system is off
                                                    no new invoices can be posted. You can also put an informational
                                                    message to the agents. This
                                                    can be a reason why the system is off, or just an informational
                                                    message.
                                                </span>
                                            </b-col>
                                        </b-row>
                                    </b-alert>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12">
                                    <b-form-group label="Select message" label-for="invoicing_message" label-cols="12"
                                        label-size="sm">
                                        <treeselect v-model="invoicing_message" :clearable="false"
                                            :options="options_invoicing_message" :disabled="false"
                                            @input="changeMessage">
                                        </treeselect>

                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row class="my-4">
                                <b-col cols="12">
                                    <b-form-group label="Informational Message" label-for="newmessage" label-cols="12">
                                        <b-input-group class="treeselect_all" style="left:120px; top:-14px">
                                            <i class="fa fa-info-circle text-black" id="newmessage"></i>
                                        </b-input-group>
                                        <b-tooltip target="newmessage" triggers="hover" placement="top">Pick a message
                                            from the drop down above
                                            or type your own message. Be sure to clear this message to turn off all
                                            informational messages to
                                            the agents, and Save It.</b-tooltip>
                                        <b-input-group>
                                            <b-form-input type="text" v-model="newmessage"
                                                placeholder="Enter new message" size="sm"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="newmessage = ''">
                                                    <i class="fa fa-remove"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="6" md="4" xl="3">
                                    <b-form-group label="Invoicing" label-for="state" label-cols="12">
                                        <b-form-radio-group id="state" v-model="state" :options="[
                                            { text: 'Off', value: '0' },
                                            { text: 'On', value: '1' },
                                        ]" buttons button-variant="outline-success" size="sm"
                                            name="radio-btn-outline"></b-form-radio-group>
                                    </b-form-group>

                                </b-col>
                            </b-row>
                        </p>
                    </b-tab></b-tabs>
            </b-card-body>

            <!-- v-if="user.permissions.includes('setup_tasksat.admin')" -->
            <b-card-footer class="nopadding mt-2">
                <b-row no-gutters>
                    <b-col cols="auto" class="text-left mr-3">
                        <b-button squared size="sm" variant="primary" @click="saveit()">
                            <i class="fa fa-check"></i>
                            Save It
                        </b-button>
                    </b-col>
                    <b-col class="text-left my-auto">
                        <div v-if="busy">
                            <i class="fa fa-spinner fa-spin text-primary"></i>
                        </div>
                        <div v-else>
                            <span v-html="message"></span>
                        </div>
                    </b-col>
                    <b-col class="text-right" cols="8">
                        <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                            <i class="fa fa-chevron-left pr-1"></i>
                            Back
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-footer>

        </b-card>
    </b-overlay>
</template>


<script>
import gql from "graphql-tag";

export default {
    name: "InvoicingOnOff",

    async mounted() {
        await this.loadit()
    },
    data() {
        return {
            busy: false,
            invoicing_message: null,
            newmessage: null,
            tabindex: 0,
            state: "0",
            items: [],
            options_invoicing_message: [
                { id: "The invoicing system is currently closed for new invoices while the accounts department close the previous month. Please check back soon.", label: "The invoicing system is currently closed for new invoices while the accounts department close the previous month. Please check back soon." },
                { id: "The invoicing system is temporarily closed for maintenance. Please check back soon.", label: "The invoicing system is temporarily closed for maintenance. Please check back soon." }

            ],
            options: {
                title: "Invoicing On/Off",
                icon: "fa fa-toggle-on",
                debounce: 500,
                fields: [],
                badges: [],
                actions: [],
            },
        };
    },

    methods: {
        changeMessage() {
            this.newmessage = this.invoicing_message

        },
        async loadit() {
            let value = ""
            value = await this.getsystemsetting("invoicing_enabled")
            if (value == 'yes') { this.state = '1' }
            value = await this.getsystemsetting("invoicing_message")
            this.newmessage = value
        },
        async saveit() {
            this.busy = true;

            let variables = {
                rows: [
                    {
                        name: 'invoicing_enabled',
                        data: this.state == '1' ? 'yes' : 'no'
                    },
                    {
                        name: 'invoicing_message',
                        data: this.newmessage
                    }
                ]
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation setup_systemsettings_save(
                            $rows: [setup_systemsettings_input]
                        ) {
                            setup_systemsettings_save(rows: $rows) {      
                            name
                            category                
                            data                              
                            }
                        }
                    `,
                    variables,
                });

                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
            
            this.$store.dispatch("invoicing")
        },
    },


};
</script>

<style scoped></style>